import { user } from './reducer';

export const { setCurrentUser, clearCurrentUser } = user.actions;
